import { render, staticRenderFns } from "./WebsiteChatbotBuilder.vue?vue&type=template&id=c3f1f4da&scoped=true"
import script from "./WebsiteChatbotBuilder.vue?vue&type=script&lang=js"
export * from "./WebsiteChatbotBuilder.vue?vue&type=script&lang=js"
import style0 from "./WebsiteChatbotBuilder.vue?vue&type=style&index=0&id=c3f1f4da&prod&lang=scss"
import style1 from "./WebsiteChatbotBuilder.vue?vue&type=style&index=1&id=c3f1f4da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f1f4da",
  null
  
)

export default component.exports